
import App from './App';
import { createRoot } from "react-dom/client";
import {createBrowserRouter,RouterProvider,} from "react-router-dom";
import { AllData } from './Data/AllData';
import AllHome from './Home/AllHome';
import AllAbout from './About/AllAbout';
import AllShop from './Shop/AllShop';
import AllContact from './Contact/AllContact';
import AllShopSingle from './ShopSingle/AllShopSingle';
import AllCart from './Cart/AllCart';
import AllFavorites from './Favorites/AllFavorites';
import AllPhone from './Phone/AllPhone';
import AllLaptop from './Laptop/AllLaptop';
import SinglePhone from './SinglePhone/SinglePhone';
import SingleLaptop from './SingleLaptop/SingleLaptop';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>
  },
  {
    path: "about",
    element:<AllAbout/>,
  },
  {
    path: "shop",
    element:<AllShop/>,
  },
  {
    path: "contact",
    element:<AllContact/>,
  },
  {
    path: "shopSingle/:id",
    element:<AllShopSingle/>,
  },
  {
    path: "SinglePhone/:id",
    element:<SinglePhone/>,
  },
  {
    path: "SingleLaptop/:id",
    element:<SingleLaptop/>,
  },
  {
    path: "cart",
    element:<AllCart/>,
  },
  {
    path: "favorites",
    element:<AllFavorites/>,
  },
  {
    path: "phone",
    element:<AllPhone/>,
  },
  {
    path: "laptop",
    element:<AllLaptop/>,
  },
]);

createRoot(document.getElementById("root")).render(
  <AllData>
  <RouterProvider router={router} />
  </AllData>
  );

